import { Component } from "@angular/core";

@Component({
  selector: "app-installation-notification-without-emission-permit",
  templateUrl:
    "./installation-notification-without-emission-permit.component.html",
  standalone: false,
})
export class InstallationNotificationWithoutEmissionPermitComponent {}
